import { Badge, BadgeProps } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import { LeadStatus as LeadStatusType, leadStatusColorMap, leadStatusTextMap } from 'entities/Lead';

import s from './LeadStatus.module.scss';

type LeadStatusProps = Omit<BadgeProps, 'variant' | 'children'> & {
  className?: string;
  labelClassName?: string;
  status: LeadStatusType;
};

const LeadStatus: React.FC<LeadStatusProps> = ({ className, labelClassName, status, size = 'lg', color, ...props }) => {
  return (
    <Badge
      className={cn(s.root, className)}
      classNames={{ label: cn(s.root__label, labelClassName) }}
      color={color ?? leadStatusColorMap[status]}
      size={size}
      variant="light"
      {...props}
    >
      {leadStatusTextMap[status].tag}
    </Badge>
  );
};

export default React.memo(LeadStatus);
